import type { JsonObject } from '../model/integration';

export interface WebhookTestResponse {
  status: number;
  body: unknown;
}

/*
Posts to the public webhook route as the external system would. A plain fetch on purpose: the app's API client would
send the admin session as Authorization, and the route reads that header as the webhook token.
*/
export const sendWebhookTest = async ({
  url,
  payload,
  token,
  dryRun,
}: {
  url: string;
  payload: JsonObject;
  token: string;
  dryRun: boolean;
}): Promise<WebhookTestResponse> => {
  const response = await fetch(dryRun ? `${url}?dryRun=true` : url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(payload),
  });
  const text = await response.text();
  let body: unknown = text;
  try {
    body = JSON.parse(text);
  } catch {
    // Not JSON: the raw text is shown
  }
  return { status: response.status, body };
};
